import { css } from 'styled-components'

export const inputStyles = css`
  .hot-form__input {
    color: inherit;
    background-color: transparent;
    border: 1px solid var(--gray-200);
  }

  .hot-form__input::placeholder,
  .hot-form__input::-webkit-input-placeholder {
    color: inherit;
  }
`
